




























import Vue from "vue";
import Component from "vue-class-component";
import {Prop, Ref, Watch} from "vue-property-decorator";
import Category from "@/modules/support/model/Category";
import {State} from "vuex-class";
import CategorySelector from "@/modules/support/components/Guide/CategorySelector.vue";
import {VForm} from "@/types";
import {notify} from "@/modules/core/notification";

/**
 * Dialogo para confirmar la eliminación de una categoría
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {CategorySelector}
})
export default class ConfirmDeleteCategory extends Vue {
    /**
     * Controla la visiblidad del componente
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Categoría actualmente seleccionada por el usuario
     */
    @State(state => state.support.currentCategory)
    public category: Category

    /**
     * Categoría de reemplazo
     */
    @State(state => state.support.replacementCategory)
    public replacement: Category

    /**
     * Referencia al formulario
     */
    @Ref('form')
    public form: VForm

    public deleting = false

    public get rules () {
        return [
            () => !!this.replacement || 'Es necesario definir una categoría de reemplazo'
        ]
    }

    @Watch('value')
    watchValue (value: boolean) {
        if (value && this.form) this.form.reset()
    }

    /**
     * Elimina la categoría
     */
    public async deleteCategory () {
        if (!this.form.validate()) {
            return
        }

        this.deleting = true
        await this.$store.dispatch('support/deleteCategory')

        this.deleting = false

        this.$emit('input', false)
        notify('La categoría ha sido eliminada correctamente')
    }

    errorCaptured () {
        this.deleting = false
    }
}
